//packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//styles
import './AlertMessage.less'

class AlertMessage extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.array,
            PropTypes.string,
            PropTypes.number,
        ])
    };

    static defaultProps = {
        children: '',
    };

    render() {
        return (
            <div className="alert-message">{this.props.children}</div>
        );
    }

}

export default AlertMessage



/** WEBPACK FOOTER **
 ** ./src/components/Modules/AlertMessage/AlertMessage.js
 **/